import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';
import InnerHTML from '@Components/InnerHTML/InnerHTML';
import ReactReactionDetailsHelper from '@Components/Results/services/react-reaction-details-helper.service';
import UserDatabases from '@Services/UserDatabases';
import Breadcrumb from '@Services/Breadcrumb';
import { CONDITIONS_RESULTS_BREADCRUMB_PARAMS } from '../constants';

const ConditionsSubstanceLabel = forwardRef(
  ({ item, id, className, textClassName, textRef, dataE2e, onBeforeNavigate, isChartLink }, ref) => {
    const label = item?.name ?? '';
    const labelContent = (
      <span ref={textRef} className={textClassName}>
        <InnerHTML html={label} mode={item?.id ? 'escape' : 'discard'} />
      </span>
    );

    if (!item?.id) {
      return (
        <span ref={ref} id={id} className={className}>
          {labelContent}
        </span>
      );
    }

    return (
      <LinkElement
        ref={ref}
        id={id}
        data-e2e={dataE2e}
        href="#"
        inline={!isChartLink}
        navigation={!isChartLink}
        className={className}
        onClick={(event) => {
          event.preventDefault();
          const databaseId = item.databaseId ?? UserDatabases.getDefaultDatabase()?.id;
          onBeforeNavigate?.();
          Breadcrumb.resetBreadcrumbs();
          ReactReactionDetailsHelper.goToContext('substances', { id: item.id, databaseId }, CONDITIONS_RESULTS_BREADCRUMB_PARAMS);
        }}>
        {labelContent}
      </LinkElement>
    );
  }
);

ConditionsSubstanceLabel.displayName = 'ConditionsSubstanceLabel';

ConditionsSubstanceLabel.propTypes = {
  id: PropTypes.string,
  item: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    databaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  className: PropTypes.string,
  textClassName: PropTypes.string,
  textRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.object })]),
  dataE2e: PropTypes.string,
  onBeforeNavigate: PropTypes.func,
  isChartLink: PropTypes.bool,
};

export default ConditionsSubstanceLabel;
